<span
  class="d-latest-rating-notch"
  [class.negative]="rating.rating === 'Sell'"
  [class.hold]="rating.rating === 'Hold'"
></span>
<div class="d-rating-item-body">
  <div
    class="d-latest-rating-row"
    [class.d-rating-expand]="isExpandable()"
    [attr.tabindex]="isExpandable() ? 0 : null"
    [attr.role]="isExpandable() ? 'button' : null"
    [attr.aria-expanded]="isExpandable() ? isExpanded() : null"
    (click)="onRowActivate()"
    (keyup.enter)="onRowActivate()"
    (keydown.space)="$event.preventDefault(); onRowActivate()"
  >
    <div class="d-latest-rating-info">
      <div class="d-latest-rating-name-row">
        <span class="d-latest-rating-name">{{ rating.name }}</span>
        @if (stars().length > 0) {
          <div class="stars">
            @for (filled of stars(); track $index) {
              <span class="star" [class.filled]="filled" [class.faded]="!filled">★</span>
            }
          </div>
        }
      </div>
      @if (metaText()) {
        <span class="d-latest-rating-meta">{{ metaText() }}</span>
      }
    </div>
    <div class="d-latest-rating-value">
      <span
        class="d-latest-rating-label"
        [class.buy]="rating.rating === 'Buy'"
        [class.sell]="rating.rating === 'Sell'"
        >{{ rating.rating }}</span
      >
      @if (priceText()) {
        <span
          class="d-latest-rating-price"
          [class.buy]="rating.rating === 'Buy'"
          [class.sell]="rating.rating === 'Sell'"
          >{{ priceText() }}</span
        >
      }
    </div>
    @if (isExpandable()) {
      <span class="d-rating-expand-icon" aria-hidden="true" [class.expanded]="isExpanded()"></span>
    }
  </div>
  @if (isExpandable() && isExpanded()) {
    <div class="d-rating-details">
      @for (metric of detailMetrics(); track metric.title; let last = $last) {
        <div class="d-rating-detail-item">
          <div class="d-rating-detail-header">
            <span class="d-rating-detail-title">{{ metric.title }}</span>
            @if (metric.value) {
              <span
                class="d-rating-detail-value"
                [class.positive]="metric.positive === true"
                [class.negative]="metric.positive === false"
                >{{ metric.value }}</span
              >
            }
          </div>
          <span class="d-legend">{{ metric.subtext }}</span>
        </div>
        @if (!last) {
          <div class="d-rating-detail-divider"></div>
        }
      }
    </div>
  }
</div>
